// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rf0CPNXmEWfLAn {
  display: block;
}
.yM38VfWiA0IdGz {
  display: none;
}
.h56hAXzACJESP0 {
  display: flex;
  width: 100%;
}
.h56hAXzACJESP0 h3 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-bottom: 14px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.XaM5X8CoHiRPpI {
  transition: opacity 0.3s ease;
}
@media (prefers-reduced-motion: reduce) {
  .XaM5X8CoHiRPpI {
    transition: none;
  }
}
.lHFM7UUNfdtsas {
  width: calc(680px + ((100vw - 960px) / 2));
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 28px var(--ds-space-0, 0) 66.5px var(--ds-space-0, 0);
  box-shadow: var(--ds-shadow-raised, inset 0 24px 14px -14px rgba(9, 30, 66, 0.15));
  font-size: 16px;
}
@media (min-width: 1200px) {
  .lHFM7UUNfdtsas {
    width: calc(807.5px + ((100vw - 1140px) / 2));
  }
}
.lHFM7UUNfdtsas > div {
  display: flex;
  flex-direction: column;
  width: 640px;
  margin: var(--ds-space-0, 0) var(--ds-space-500, 40px) var(--ds-space-0, 0) auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-0, 0) 28px var(--ds-space-0, 0) 14px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 14px;
}
@media (min-width: 1200px) {
  .lHFM7UUNfdtsas > div {
    width: 760px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin: var(--ds-space-0, 0) 47.5px var(--ds-space-0, 0) auto;
  }
}
.jwtVp6sY8rpIGr {
  width: calc(280px + ((100vw - 960px) / 2));
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 28px var(--ds-space-0, 0) 66.5px;
  background-color: var(--ds-background-accent-purple-subtlest, rgba(234, 230, 255, 0.4));
  box-shadow: var(--ds-shadow-raised, inset 0 24px 14px -14px rgba(9, 30, 66, 0.15));
}
@media (min-width: 1200px) {
  .jwtVp6sY8rpIGr {
    width: calc(332.5px + ((100vw - 1140px) / 2));
  }
}
.jwtVp6sY8rpIGr > div {
  width: 240px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: var(--ds-space-0, 0) auto var(--ds-space-0, 0) calc(var(--ds-space-500, 40px) - 14px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
@media (min-width: 1200px) {
  .jwtVp6sY8rpIGr > div {
    width: 285px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin: var(--ds-space-0, 0) auto var(--ds-space-0, 0) calc(47.5px - 14px);
  }
}
.jwtVp6sY8rpIGr > div p {
  margin-bottom: var(--ds-space-100, 8px);
}
.jwtVp6sY8rpIGr h3 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 14px;
  border-bottom-color: var(--ds-border-accent-purple, #998dd9);
}
.aH5JpHQiJOJ8y5 {
  display: flex;
  flex-wrap: wrap;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: var(--ds-space-0, 0) -14px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 14px var(--ds-space-0, 0);
}
.skEgOKe2Mo1nvi {
  display: flex;
  flex-direction: column;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 14px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: -14px;
  padding: var(--ds-space-300, 24px) var(--ds-space-0, 0);
  text-decoration: none;
}
.skEgOKe2Mo1nvi a {
  padding-bottom: var(--ds-space-0, 0);
  text-decoration: none;
}
.skEgOKe2Mo1nvi p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.aH5JpHQiJOJ8y5 > a {
  width: 33.33333%;
  text-decoration: none;
}
.aH5JpHQiJOJ8y5 > a > p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailVisible": `rf0CPNXmEWfLAn`,
	"detailHidden": `yM38VfWiA0IdGz`,
	"detail": `h56hAXzACJESP0`,
	"detailInner": `XaM5X8CoHiRPpI`,
	"detailPrimary": `lHFM7UUNfdtsas`,
	"detailSecondary": `jwtVp6sY8rpIGr`,
	"detailPrimaryLinks": `aH5JpHQiJOJ8y5`,
	"detailSecondaryLinks": `skEgOKe2Mo1nvi`
};
export default ___CSS_LOADER_EXPORT___;
